// Selector de periodo de Comisiones pagadas, con el rango de cortes que suma.
import {
    PAYOUT_PERIOD_OPTIONS,
    parsePayoutPeriod,
    periodRange,
    weekLabel,
    weekStart,
    type PayoutPeriod,
} from '../../lib/payoutPeriods';
import { FIELD, LABEL } from '../fieldStyles';

interface PayoutPeriodSelectProps {
    period: PayoutPeriod;
    onChange: (period: PayoutPeriod) => void;
    today: string;
}

export function PayoutPeriodSelect({ period, onChange, today }: PayoutPeriodSelectProps) {
    const range = periodRange(period, today);
    return (
        <div>
            <label htmlFor="payout-period" className={LABEL}>
                Periodo
            </label>
            <select
                id="payout-period"
                className={FIELD}
                value={period}
                onChange={(event) => {
                    onChange(parsePayoutPeriod(event.target.value));
                }}
            >
                {PAYOUT_PERIOD_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            <p className="mt-1 text-[10px] italic text-muted-foreground">
                {range
                    ? `Cortes cerrados desde la semana del ${weekLabel(range.from)}, más la semana en curso`
                    : `Corte en curso · ${weekLabel(weekStart(today))}`}
            </p>
        </div>
    );
}
